import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import PasswordInput from "../components/PasswordInput";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { api, apiError } from "../lib/api";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      toast.error("Link non valido: manca il token. Richiedi un nuovo reset.");
      return;
    }
    if (pw1.length < 8) {
      toast.error("La password deve essere lunga almeno 8 caratteri.");
      return;
    }
    if (pw1 !== pw2) {
      toast.error("Le due password non coincidono.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw1 });
      toast.success("Password aggiornata. Accedi con la nuova password.");
      navigate("/cliente/login");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthShell
        side="client"
        title="Link non valido"
        subtitle="Manca il codice di reset nell'URL."
        altLinkLabel="← Torna al login"
        altLinkTo="/cliente/login"
      >
        <div className="rounded-2xl border border-[var(--mp-border)] bg-[var(--mp-dash-bg)] p-6 space-y-4">
          <p className="text-sm text-[var(--mp-muted)] leading-relaxed">
            Il link che hai aperto non è completo. Richiedi un nuovo link di reset dalla
            pagina "Password dimenticata?".
          </p>
          <Link
            to="/password-dimenticata"
            className="inline-flex items-center h-10 px-4 rounded-full bg-[var(--mp-ink)] text-white text-sm font-semibold"
          >
            Richiedi nuovo link
          </Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      side="client"
      title="Scegli una nuova password"
      subtitle="Minimo 8 caratteri. Dopo il reset verrai portato al login."
      altLinkLabel="← Torna al login"
      altLinkTo="/cliente/login"
      altLinkDataTestId="reset-to-login"
    >
      <form onSubmit={onSubmit} data-testid="reset-form" className="space-y-5">
        <div>
          <Label
            htmlFor="pw1"
            className="text-xs font-bold uppercase tracking-[0.18em]"
          >
            Nuova password
          </Label>
          <PasswordInput
            id="pw1"
            dataTestId="reset-pw1"
            required
            autoFocus
            value={pw1}
            onChange={(e) => setPw1(e.target.value)}
            className="mt-2 h-12 rounded-xl border-[var(--mp-ink)]"
            placeholder="Almeno 8 caratteri"
          />
        </div>
        <div>
          <Label
            htmlFor="pw2"
            className="text-xs font-bold uppercase tracking-[0.18em]"
          >
            Conferma password
          </Label>
          <PasswordInput
            id="pw2"
            dataTestId="reset-pw2"
            required
            value={pw2}
            onChange={(e) => setPw2(e.target.value)}
            className="mt-2 h-12 rounded-xl border-[var(--mp-ink)]"
            placeholder="Ripeti la password"
          />
        </div>
        <Button
          type="submit"
          disabled={loading}
          data-testid="reset-submit"
          className="w-full h-12 rounded-full bg-[var(--mp-ink)] hover:bg-black text-white"
        >
          {loading ? "Aggiorno…" : "Aggiorna password"}
        </Button>
      </form>
    </AuthShell>
  );
}
